import type { ComponentType } from 'react';
import type { PuzzleType } from '@il-colpo/engine';
import { CamerasPanel } from './CamerasPanel.tsx';
import { CorridorPanel } from './CorridorPanel.tsx';
import { EscapePanel } from './EscapePanel.tsx';
import { LaserPanel } from './LaserPanel.tsx';
import { LockPanel } from './LockPanel.tsx';
import { PanelPanel } from './PanelPanel.tsx';
import { PasswordPanel } from './PasswordPanel.tsx';
import { SafePanel } from './SafePanel.tsx';
import { VaultPanel } from './VaultPanel.tsx';
import type { PuzzleProps } from './shared.tsx';

/** One screen per puzzle; each shows what the player's role sees and lets them act on it. */
export const PUZZLE_PANELS: Record<PuzzleType, ComponentType<PuzzleProps>> = {
  lock: LockPanel,
  safe: SafePanel,
  panel: PanelPanel,
  cameras: CamerasPanel,
  laser: LaserPanel,
  password: PasswordPanel,
  corridor: CorridorPanel,
  escape: EscapePanel,
  vault: VaultPanel,
};
